<template>
  <v-container style="max-width:1000px" class="mt-8">
    <h1>{{data.name}}</h1>
    <p>{{data.description}}</p>

    <v-expansion-panels v-model="panel">
        <v-expansion-panel>
            <v-expansion-panel-header>Show Data Table</v-expansion-panel-header>
            <v-expansion-panel-content>
              <DataTable :headers="headers" :items="items" text="Show Data Table"/>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header><span>Pick one of our <strong>pipeline presets</strong></span></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select
                v-model="presetChoice"
                :items="preset_choices"
                item-text="text"
                item-value="value"
                hint="Select a pipeline preset"
                persistent-hint
                single-line
                v-on:change="changePreset"
                ></v-select>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header><span>Select your own pipeline configuration in <strong>expert mode</strong></span></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select
                v-model="payloadMap.support_algorithm"
                :items="support_choices"
                item-text="text"
                item-value="value"
                hint="Select a support algorithm"
                persistent-hint
                single-line
                ></v-select>
              <v-select
                v-model="payloadMap.insertion_algorithm"
                :items="insertion_choices"
                item-text="text"
                item-value="value"
                hint="Select an insertion algorithm"
                persistent-hint
                single-line
                ></v-select>
              <v-select
                v-model="payloadMap.initial_layout_algorithm"
                :items="initial_layout_choices"
                item-text="text"
                item-value="value"
                hint="Select a layout algorithm"
                persistent-hint
                single-line
                ></v-select>
              <v-select
                v-model="payloadMap.schematization_algorithm"
                :items="schematization_choices"
                item-text="text"
                item-value="value"
                hint="Select a schematization algorithm"
                persistent-hint
                single-line
                ></v-select>

                <div v-if="canSort">
                  <v-checkbox
                    v-model="payloadMap.hasSorting"
                    label="Apply defined partial order"
                  />
                  <v-select
                  v-model="payloadMap.sortColumn"
                  :items="sortObject"
                  item-text="key"
                  item-value="column"
                  :disabled="!payloadMap.hasSorting"
                  hint="Select an attribute for ordering along a metro line"
                  persistent-hint
                  single-line
                  ></v-select>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
    <v-btn class="ma-2 textSecondary--text" tile color="secondary"  @click="createMap" :loading="loading">Create</v-btn>
  </v-container>
</template>

<script>

import DataTable from '../components/DataTable.vue'

export default {
  name: 'Data',
  components: {
    DataTable
  },
  data () {
    return {
      hasData: false,
      data: '',
      payloadMap: {
        data: '',
        support_algorithm: '',
        initial_layout_algorithm: '',
        insertion_algorithm: '',
        schematization_algorithm: '',
        hasSorting: false,
        sortColumn: 0
      },
      panel: 1,
      presetChoice: '',
      preset_choices: '',
      sortObject: [],
      loading: false,
      headers: [],
      items: [],
      formData: '',
      support_choices: '',
      initial_layout_choices: '',
      insertion_choices: '',
      schematization_choices: '',
      canSort: false,
      sort_choices: ''
    }
  },
  created () {
    this.all()
    this.loadForms()
  },
  methods: {
    all: function () {
      this.axios.get('data/' + this.$route.params.dataId)
        .then(response => {
          this.data = response.data
          this.hasData = true

          this.sort_choices = []

          this.data['dataColumns'].forEach(item => this.sort_choices.push({ value: item, text: this.data.raw[0][item] }))

          this.headers = [{ value: this.data.raw[0][0], text: this.data.raw[0][0] }]
          this.data.setColumns.forEach(d => {
            this.headers.push({ value: this.data.raw[0][d], text: this.data.raw[0][d] })
          })

          this.data.dataColumns.forEach(d => {
            this.sortObject.push({ key: this.data.raw[0][d], value: '', column: d })
            this.headers.push({ value: this.data.raw[0][d], text: this.data.raw[0][d] })
          })

          if (this.sortObject.length > 0) {
            this.canSort = true
            this.payloadMap.sortColumn = this.sort_choices[0].value
          }

          this.items = []
          this.data.raw.forEach((row, ind) => {
            if (ind < 1) {
              return
            }

            var entry = {}
            row.forEach((elem, i) => {
              entry[this.data.raw[0][i]] = elem
            })
            this.items.push(entry)
          })

          this.payloadMap.data = this.data.id
        }, (error) => {
          this.loading = false
          this.errorMessage = error
          this.hasError = true
          this.$router.push({ name: '404' })
        })
    },

    loadForms: function () {
      this.axios.get('form_choices/')
        .then(response => {
          this.formData = response.data

          this.support_choices = []
          this.initial_layout_choices = []
          this.insertion_choices = []
          this.schematization_choices = []
          this.preset_choices = []

          this.formData['support_choices'].forEach(item => this.support_choices.push({ value: item[0], text: item[1] }))
          this.formData['initial_layout_choices'].forEach(item => this.initial_layout_choices.push({ value: item[0], text: item[1] }))
          this.formData['insertion_choices'].forEach(item => this.insertion_choices.push({ value: item[0], text: item[1] }))
          this.formData['schematization_choices'].forEach(item => this.schematization_choices.push({ value: item[0], text: item[1] }))

          for (const [key, value] of Object.entries(this.formData['presets'])) {
            this.preset_choices.push({ value: value, text: key })
          }
          this.presetChoice = this.preset_choices[0]['value']
          this.payloadMap.support_algorithm = this.support_choices[this.presetChoice[0]]['value']
          this.payloadMap.initial_layout_algorithm = this.initial_layout_choices[this.presetChoice[2]]['value']
          this.payloadMap.insertion_algorithm = this.insertion_choices[this.presetChoice[1]]['value']
          this.payloadMap.schematization_algorithm = this.schematization_choices[this.presetChoice[3]]['value']
        })
    },

    changePreset: function () {
      this.payloadMap.support_algorithm = this.support_choices[this.presetChoice[0]]['value']
      this.payloadMap.initial_layout_algorithm = this.initial_layout_choices[this.presetChoice[2]]['value']
      this.payloadMap.insertion_algorithm = this.insertion_choices[this.presetChoice[1]]['value']
      this.payloadMap.schematization_algorithm = this.schematization_choices[this.presetChoice[3]]['value']
    },

    createMap: function () {
      this.loading = true
      this.axios
        .post('maps/',
          this.payloadMap
        )
        .then(response => {
          this.loading = false
          this.$router.push({ name: 'mapDetail', params: { mapId: response.data } })
        }, (error) => {
          this.loading = false
          this.errorMessage = error
          this.hasError = true
        })
    }
  }
}
</script>
